import { Component, Input, OnInit } from '@angular/core';

import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-plantillas-popover',
  templateUrl: './plantillas-popover.component.html',
  styleUrls: ['./plantillas-popover.component.scss'],
})
export class PlantillasPopoverComponent implements OnInit {

  @Input() plantillas: any[] = [];
  @Input() selectedPlantilla: any = null;

  constructor(private popoverController: PopoverController) { }

  ngOnInit() { }

  selectPlantilla(plantilla) {
    this.popoverController.dismiss(plantilla);
  }

  closePopover() {
    this.popoverController.dismiss();
  }

}
